module.exports = __webpack_public_path__ + "assets/basicbg-3b05f78ea8213c38cf6f6b54044f7e76.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/basicbg.png
// module id = 54
// module chunks = 4